module.exports = __webpack_public_path__ + "img/cms1.5768138e.webp";